/* src/app/system-utils/tooltip/tooltip.component.scss */
.tooltipComponent {
  position: absolute;
  min-width: 200px;
  min-height: 150px;
}
.tooltipComponent .left {
  background-color: #FFFFE1;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 13px;
  z-index: 9999999;
  transform: translateX(-50%);
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}
.tooltipComponent i {
  position: absolute;
  margin-top: -20px;
  width: 12px;
  height: 24px;
  left: 100px;
  top: 50%;
  overflow: hidden;
}
.tooltipComponent i::before {
  content: "";
  width: 0;
  height: 0;
  width: 12px;
  height: 12px;
  right: 0;
  position: absolute;
  transform: translate(-50%, -50%) rotate(45deg);
  background-color: white;
  top: 50%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}
.newToolTipComponent {
  background-color: #ffc;
  border-radius: 4px;
  padding: 1em;
  font-size: 13px;
  box-sizing: border-box;
  box-shadow: 5px 5px 7px rgba(33, 33, 33, 0.7);
  min-width: 200px;
  min-height: 150px;
}
/*# sourceMappingURL=tooltip.component.css.map */
